import * as React from "react";
import {
  Provider as PaperProvider,
  Text,
  TextInput,
  DefaultTheme,
  Divider,
} from "react-native-paper";
import {
  Image,
  StyleSheet,
  View,
  TouchableOpacity,
  ScrollView,
  Dimensions,
} from "react-native";
import { connect } from "react-redux";
import { actionCreators } from "./action";
import { actionCreators as actionCreatorsRegistrationForm } from "../RegistrationForm/action";
import { actionCreators as actionCreatorsForgotPassword } from "../ForgotPassword/action";
import {
  whiteColor,
  blackColor,
  greyColor,
  redBorderInputColor,
  redBackgroundColor,
} from "../../common/colors";
import { linkColorForgot } from "../../common/colors";
import Button from "../../common/Button";
import routes from "../../routing/routes";
import Link from "../../common/Link";
import Error from "../../common/Error";
import ErrorPasswordInvalid from "../../common/Error/ErrorPasswordInvalid";
import checker, { enumChecker } from "../../common/helpers/checker";
import PageContainer from "../../common/PageContainer";
/* import logoApple from '../Images/LogoApple.png';
import logoFacebook from '../Images/LogoFacebook.png';
import logoGoogle from '../Images/LogoGoogle.png';*/
import MAX_WIDTH from '../../common/MaxWidth';
import t from '../../translations';

const inputPadding = 12;

const LogIn = (props) => {
  const [email, setEmail] = React.useState("");
  const [password, setPassword] = React.useState("");

  React.useEffect(() => {
    if (props.error) {
      props.saveErrorReponse(null);
    }
    return () => {
      props.saveErrorReponse(null);
    };
  }, []);

  const theme = {
    ...DefaultTheme,
    roundness: 0,
    colors: {
      ...DefaultTheme.colors,
      primary: blackColor,
    },
  };

  const onClickLink = () => props.navigation.navigate(routes.RegistrationForm);
  const onClickLinkForgotPassword = () =>
    props.navigation.navigate(routes.ForgotPassword);
  const isWrongPassword = props.errorCode === enumChecker.wrongPassword;
  const isNotWrongPassword = !isWrongPassword && props.error;
  const onPressButton = () =>
    props.login({ email, password, redirect: props.navigation.navigate });

  const win = Dimensions.get("window");

  return (
    <PageContainer
    {...props}
    noBackground={true}
    isBackIcon={true}
    backRoute={routes.Start}
    maxWidth={MAX_WIDTH.AUTHENTICATION}
    >
      <View style={styles.container}>
        <Text style={styles.title}>{t('login_signin')}</Text>
      </View>
      <View style={styles.inputsContainer}>
        <TextInput
          label={t('login_forgot_e_mail')}
          value={email}
          onChangeText={(text) => {
            setEmail(text);
            isNotWrongPassword && props.saveErrorReponse(null);
          }}
          mode="outlined"
          returnKeyType="done"
          error={isNotWrongPassword && { ...styles.inputBorderError, width: '100%' }}
          style={isNotWrongPassword ? { ...styles.inputError, width: '100%' }

            : { ...styles.input, width: '100%' }}

        />
        {isNotWrongPassword && <Error error={props.error} />}
        <TextInput
          label={t('login_forgot_password')}
          value={password}
          onChangeText={(text) => {
            setPassword(text);
            isWrongPassword && props.saveErrorReponse(null);
          }}
          secureTextEntry={true}
          mode="outlined"
          returnKeyType="go"
          onSubmitEditing={onPressButton}
          error={isWrongPassword && { ...styles.inputBorderError, width: '100%' }}
          style={isWrongPassword ? { ...styles.inputError, width: '100%' }
            :
            { ...styles.input, width: '100%' }}
        />
      </View>
      <View style={styles.inputsContainerLeft}>
        {isWrongPassword && <ErrorPasswordInvalid error={props.error} />}
        <View style={styles.forgotPassword}>
          <Text
            style={styles.linkForgotPassword}
            onPress={onClickLinkForgotPassword}
          >
            {t('login_forgot_passowrd')}
          </Text>
        </View>
      </View>
      <View style={styles.inputsContainer}>
        <View style={styles.buttonContainer}>
          <Button onPress={onPressButton} value={t('login_signin')} />
        </View>
        {/* <View style={styles.linecontainer}>
                <Divider style={styles.breakline}>
                <Text style={styles.or}>Lub</Text>
                </Divider>
            </View>
            <View style={styles.continue}>
                <Text style={styles.continuewithaccounts}>Kontynnuj za pomocą:</Text>
            </View> */}
        {/* <View style={styles.logoicons}>
                <View style={styles.emptyspace}>
                    <TouchableOpacity onPress={()=>props.signInWithApple({redirect: props.navigation.navigate})}>
                        <Image source={logoApple} style={styles.logo}/>
                    </TouchableOpacity>
                </View>
                <View style={styles.emptyspace}>
                    <TouchableOpacity onPress={()=>props.signInWithFacebook({redirect: props.navigation.navigate})}>
                        <Image source={logoFacebook} style={styles.logo}/>
                    </TouchableOpacity>
                </View>
                <TouchableOpacity onPress={()=>props.signInWithGoogle({redirect: props.navigation.navigate})}>
                    <Image source={logoGoogle} style={styles.logo}/>
                </TouchableOpacity>
            </View> */}
      </View>
      <View style={styles.inputsContainerLeft}>
        <View style={styles.footerContainer}>
          <Text style={styles.askbox}>{t('login_do_you_have_a_profie')}</Text>
          <Link onPress={onClickLink}> {t('login_create_account')}</Link>
        </View>
      </View>
    </PageContainer>
  );
};
const mapStateToProps = (state) => {
  const errorMessage = state.errorMessages && checker(state.errorMessages.code);
  const errorCode = state.errorMessages ? state.errorMessages.code : "";

  return { error: errorMessage, errorCode };
};

export default connect(mapStateToProps, {
  ...actionCreators,
  ...actionCreatorsRegistrationForm,
  ...actionCreatorsForgotPassword,
})(LogIn);

const styles = StyleSheet.create({
  forgotPassword: {
    left: 0,
  },
  wrapper: {
    alignItems: "center",
    position: "absolute",
    top: 0,
    bottom: 0,
    left: 0,
    right: 0,
    paddingTop: 30,
    backgroundColor: whiteColor,
  },
  inputsContainer: {
    backgroundColor: whiteColor,
    alignItems: "flex-start",
    display: "flex",
    width: '100%',
  },
  input: {
    paddingTop: 22,
    paddingBottom: 10,
    backgroundColor: whiteColor,
    height: 42,
  },
  inputBorderError: {
    borderColor: redBorderInputColor,
    borderWidth: 1,
    borderStyle: "solid",
  },
  inputError: {
    paddingTop: 10,
    paddingBottom: 10,
    backgroundColor: redBackgroundColor,
    height: 42,
  },
  container: {
    backgroundColor: whiteColor,
    alignSelf: 'flex-start',
  },
  title: {
    textAlign: "center",
    fontSize: 26,
    paddingRight: 5,
    letterSpacing: 1.25,
    textTransform: "uppercase",
  },
  buttonContainer: {
    alignItems: "center",
    display: "flex",
    paddingTop: 10,
    alignSelf: 'center',
  },
  linkForgotPassword: {
    color: linkColorForgot,
    paddingBottom: 20,
    fontSize: 12,
    letterSpacing: 1.25,
    lineHeight: 16,
  },
  linecontainer: {
    backgroundColor: whiteColor,
    width: 260,
    paddingTop: 50,
    paddingBottom: 16,
  },
  breakline: {
    height: 1,
    backgroundColor: greyColor,
  },
  or: {
    textAlign: "center",
    alignSelf: "center",
    width: 45,
    height: 10,
    marginTop: -6,
    color: greyColor,
    fontSize: 10,
    letterSpacing: 1.25,
    backgroundColor: whiteColor,
  },
  continue: {
    paddingTop: 10,
  },
  continuewithaccounts: {
    color: blackColor,
    fontSize: 12,
    letterSpacing: 1.25,
  },
  logoicons: {
    paddingTop: 12,
    alignItems: "center",
    display: "flex",
    flexDirection: "row",
  },
  logo: {
    width: 56,
    height: 56,
    alignItems: "center",
  },
  emptyspace: {
    paddingRight: 26,
  },
  footerContainer: {
    alignItems: "flex-start",
    display: "flex",
    flexDirection: "row",
    paddingTop: 20,
    paddingRight: 30,
  },
  inputsContainerLeft: {
    backgroundColor: whiteColor,
    alignItems: "flex-start",
    paddingBottom: 40,
  },
  askbox: {
    fontSize: 12,
    letterSpacing: 1.25,
    color: greyColor,
  },
});
